export const COC_NUMBER_PROP = "CoC number";
export const VAT_NUMBER_PROP = "VAT number";
export const COMPANY_NAME_PROP = "organization_name";
export const EXCLUDED_DELIVERY_DATES = "Excluded delivery days";

export const AVAILABLE_PROPERTIES = ["merk", "accu_type", "ip_certificering"];

export const NOT_AVAILABLE_PROPERTIES = ["tabelveld_html", "tabelveld_json"];
